import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router';
import { useAccount } from 'wagmi';

import PageBackground from 'components/Background';
import { useGameDetails, useKeyPress } from 'utils/Hooks';
import { MobileContext } from 'context';
import { HistoryManager } from 'components/History';
import HistoryLoadingScreen from 'utils/HistoryLoadingScreen';
import { BackButton } from 'utils/Misc';
import 'pages/styles.scss';
import './styles.scss';

function History(props) {
  const isMobile = useContext(MobileContext);
  const gameDetails = useGameDetails();

  const navigate = useNavigate();
  const account = useAccount();

  const [isLoaded, MarkPageFullyLoaded] = useState(false);

  useKeyPress(['Backspace'], () => navigate(-1));

  useEffect(MobileStatusChanged
    , [isMobile]); // eslint-disable-line react-hooks/exhaustive-deps


  function PageLoaded() {
    if (!isLoaded)
      MarkPageFullyLoaded(true);
  }
  function MobileStatusChanged() {
    if (isLoaded)
      MarkPageFullyLoaded(false);
  }
  function HideWhenLoading() {
    return { display: isLoaded ? 'flex' : 'none' }
  }


  function LegacyHistoryButton() {
    const target = (window.location.pathname).replace('history', 'history_legacy');
    return (<Link to={target} className='ThemeButton Gold Legacy'>
      Old Contract History
    </Link>);
  }

  function RegularHistoryButton() {
    const target = (window.location.pathname).replace('history_legacy', 'history');
    return (<Link to={target} className='ThemeButton Gold Legacy'>
      New Contract History
    </Link>);
  }

  function LegacyPageButton() {
    if (gameDetails.wantedChain.name != 'bsc')
      return null;
    const location = window.location.pathname;
    if (location.includes('history_legacy'))
      return RegularHistoryButton();
    else if (location.includes('history'))
      return LegacyHistoryButton();
    else
      return LegacyHistoryButton();
  }

  function ClaimAllButton() {
    const target = window.location.pathname + '/claimall';
    return (<Link to={target} className='ThemeButton Gold ClaimAllToggle'>
      Claim All
    </Link>);
  }



  if (!account?.address)
    return (
      <div className='ConnectWalletNotice'>
        <h1 className='white-centered-text'>
          Please connect your wallet first!
        </h1>
      </div>
    );
  else
    return (
      <React.Fragment>
        <HistoryLoadingScreen isLoaded={isLoaded} />
        <div className={'HistoryMain' + (isMobile ? ' Mobile' : '')} style={HideWhenLoading()}>
          <div className={'HistoryButtons' + (isMobile ? ' Mobile' : '')}>
            <BackButton />
            {/*<LegacyPageButton />*/}
            <ClaimAllButton />
          </div>
          <HistoryManager
            OnLoad={PageLoaded}
          />
          <PageBackground />
        </div>
      </React.Fragment>
    );
};

export default History;
